import React from 'react'


function Error() {
    
    return (
        <div>
                <h1>Error</h1>
PAGE NOT FOUND!
            </div>
       
    );
}

export default Error;
